import {
  Button,
  Col,
  Form,
  Input,
  Row,
  notification,
  Divider,
  Checkbox,
  Drawer,
  Modal,
  InputNumber,
  Select,
  Spin,
  List,
  Carousel,
} from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleRight,
  faAngleLeft,
  faStar,
  faClose,
} from "@fortawesome/free-solid-svg-icons";
import "moment/locale/vi"; // Import locale tiếng Việt
import React from "react";
import $axios from "../../services/axios";
import Slider from "react-slick";
import RoomItem from "./RoomItem";
import _ from "lodash";
import dayjs from "dayjs";
import { MEAL_TYPE } from "../../helpers/const";
import axios from "axios";
import { useChooseHotelLogic } from "../../hooks/useChooseHotelLogic";

const ChooseHotel = ({
  hotelSelected,
  open,
  setOpenChooseHotel,
  setHotelSelected,
  addPrice = 0,
  formSearch,
  filterSearch,
}) => {
  const {
    openViewMap,
    setOpenViewMap,
    formRef,
    form,
    step,
    setStep,
    expandedDes,
    setExpandedDes,
    roomSelected,
    rateSelected,
    voucherValue,
    setVoucherValue,
    voucherCode,
    setVoucherCode,
    voucherTxt,
    setVoucherTxt,
    loadingBooking,
    setLoadingBooking,
    loading,
    setLoading,
    nav1,
    setNav1,
    nav2,
    setNav2,
    invoice,
    setInvoice,
    invoiceCode,
    setInvoiceCode,
    adtChoosed,
    setAdtChoosed,
    isPersonChecking,
    setIsPersonChecking,
    userInfo,
    sliderRef1,
    sliderRef2,
    vouchers,
    openVoucher,
    setOpenVoucher,
    openHotelImagePreview,
    setOpenHotelImagePreview,
    toggleExpand,
    applyVoucher,
    applyVoucherPick,
    handleBooking,
    CheckProductAvailability,
    debouncedCheckMst,
    handleValueChanges,
  } = useChooseHotelLogic({ hotelSelected, formSearch, filterSearch });

  return (
    <>
      <Drawer
        title={step === 1 ? "1. CHỌN PHÒNG" : "2. THÔNG TIN KHÁCH HÀNG "}
        placement={"bottom"}
        closable={true}
        onClose={() => {
          setOpenChooseHotel(false);
          setHotelSelected(null);
        }}
        className="drawer-no-padding"
        open={open}
        type="primary"
        width="100%"
        footer={
          step === 2 && (
            <div className="flex justify-between gap-5 mt-5">
              <Button
                className="w-full h-[50px] bg-white  text-primary"
                onClick={() => setStep(1)}
              >
                <FontAwesomeIcon icon={faAngleLeft} />
                <span className="text-[16px]">Quay lại</span>{" "}
              </Button>
              <Button
                className="w-full h-[50px]  text-white"
                loading={loadingBooking}
                type="primary"
                onClick={() => {
                  formRef.current.submit();
                }}
              >
                <span className="text-[16px]">Thanh toán</span>{" "}
                <FontAwesomeIcon icon={faAngleRight} color="white" />
              </Button>
            </div>
          )
        }
        height={"100%"}
      >
        <Spin tip="Tải dữ liệu" size="large" spinning={loading}>
          {step === 1 ? (
            <div className="pb-[18px]">
              {hotelSelected.images && hotelSelected.images.length > 0 ? (
                <div className="slider-container mb-[32px] cursor-pointer" onClick={() => setOpenHotelImagePreview(true)}>
                  <Slider
                    className="slider-main"
                    asNavFor={sliderRef2.current}
                    ref={sliderRef1}
                  >
                    {hotelSelected.images.map((slide, index) => (
                      <div key={index}>
                        <img src={slide.origin} className="w-full" alt="" />
                      </div>
                    ))}
                  </Slider>
                  <Slider
                    asNavFor={sliderRef1.current}
                    ref={sliderRef2}
                    slidesToShow={4}
                    className="slider-thumbnails"
                    swipeToSlide={true}
                    focusOnSelect={true}
                    arrows={false}
                  >
                    {hotelSelected.images.map((slide, index) => (
                      <div key={index}>
                        <img
                          src={slide.origin}
                          className="w-full h-auto"
                          alt=""
                        />
                      </div>
                    ))}
                  </Slider>
                </div>
              ) : (
                <div
                  className="relative w-full cursor-pointer"
                  style={{ paddingTop: "56.25%" }}
                  onClick={() => hotelSelected?.Thumbnail && setOpenHotelImagePreview(true)}
                >
                  <img
                    src={hotelSelected?.Thumbnail?.origin}
                    alt=""
                    className="absolute top-0 left-0 w-full h-full object-cover"
                  />
                </div>
              )}

              <div className="p-3">
                <div className="flex gap-3 items-center">
                  <div className="flex gap-3 w-1/2">
                    <span className="uppercase text-[#191919] text-[12px] font-semibold">
                      {hotelSelected?.Category?.name}
                    </span>
                    <div className="flex gap-1 items-center">
                      {_.range(1, hotelSelected?.Rating?.starNumber + 1).map(
                        (s) => (
                          <FontAwesomeIcon
                            key={s}
                            icon={faStar}
                            color="#f6d738"
                            style={{
                              fontSize: 18,
                            }}
                          />
                        )
                      )}
                    </div>
                  </div>
                  {hotelSelected.Images.length > 0 && (
                    <div className="w-1/2 text-right">
                      <a
                        href="#!"
                        onClick={(e) => {
                          e.preventDefault();
                          setOpenHotelImagePreview(true);
                        }}
                        className="text-primary text-[13px] underline cursor-pointer"
                      >
                        Xem ảnh ({hotelSelected.Images.length})
                      </a>
                    </div>
                  )}
                </div>
                <h3 className="text-[18px] mt-3 font-bold text-[#15284a]">
                  {hotelSelected?.Name}
                </h3>
                <hr className="my-2" />
                <div
                  className="flex h-[80px] mt-[24px] cursor-pointer"
                  onClick={() => setOpenViewMap(true)}
                  style={{
                    backgroundImage: `url(/images/bg_map_address_hotel.svg)`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "center center",
                  }}
                >
                  <div className="pr-[100px] pl-[20px] pt-[10px] text-[#15284a]">
                    {hotelSelected?.Address || hotelSelected?.AddressObj?.address}
                  </div>
                </div>
                <div className="text-primary text-[14px] text-left flex gap-2 my-2">
                  <span>Checkin: {hotelSelected?.Checkin?.beginTime}</span>{" "}
                  <span> - </span>
                  <span>Checkout: {hotelSelected?.Checkout?.time}</span>
                </div>
                <div className="text-[16px] text-[#15284a] font-semibold mt-4">
                  Giới thiệu về khách sạn
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: expandedDes
                      ? hotelSelected?.Description
                      : hotelSelected?.Description?.slice(0, 300) + "...",
                  }}
                  className="text-gray-700 duration-300 my-1"
                />
                <div onClick={toggleExpand} className="text-center my-4">
                  <span className="text-primary">
                    {" "}
                    {expandedDes ? "Thu gọn" : "Xem thêm"}
                  </span>
                </div>
              </div>
              <div className="bg-white h-[40px] text-center flex items-center justify-center">
                <h3 className="text-secondary font-bold uppercase">
                  Danh sách phòng
                </h3>
              </div>
              {hotelSelected.rooms.length > 0 &&
                hotelSelected.rooms.map((room, index) => (
                  <>
                    <RoomItem
                      indexRoom={index + 1}
                      key={room.id}
                      addPrice={addPrice}
                      setRoomRateSelected={(rate, room) => {
                        CheckProductAvailability(rate, room);
                      }}
                      data={room}
                    />
                    <Divider className="my-4" />
                  </>
                ))}
              <div className="text-center mt-4">
                <span className="text-primary font-semibold">
                  Hotline hỗ trợ khách hàng:{" "}
                </span>
                <a
                  href="tel:1900255585"
                  className="font-bold text-primary text-[16px]"
                >
                  0876.100.800
                </a>
              </div>
              <Modal
                title={hotelSelected?.Name}
                open={openViewMap}
                closable={true}
                footer={null}
                className="modal-view-map"
                closeIcon={
                  <FontAwesomeIcon
                    icon={faClose}
                    className="w-full text-primary"
                    style={{ fontSize: 24 }}
                    onClick={() => setOpenViewMap(false)}
                  />
                }
              >
                <iframe
                  width="100%"
                  height="450"
                  title="hotel-map"
                  style={{ border: "0" }}
                  allowFullScreen
                  referrerPolicy="no-referrer-when-downgrade"
                  src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyBAaCzG3gF-9CgHyXApQaVpaQtOANYyRNI&q=${hotelSelected?.AddressObj?.coordinate?.latitude},${hotelSelected?.AddressObj?.coordinate?.longitude}`}
                ></iframe>
              </Modal>
            </div>
          ) : (
            <div className="p-4">
              <Form
                layout="vertical"
                form={form}
                ref={formRef}
                onFinish={handleBooking}
                onFinishFailed={(values) => {
                  notification.error({
                    message: "Thông báo",
                    description: "Vui lòng nhập đầy đủ thông tin",
                  });
                }}
                initialValues={{
                  contactPhone: userInfo?.phone,
                  contactEmail: userInfo?.email,
                  contactFirstName: _.head(_.split(userInfo?.name, " ")),
                  contactLastName: _.join(_.tail(_.split(userInfo?.name, " ")), " "),
                }}
                autoComplete="off"
                className="form"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                onValuesChange={handleValueChanges}
              >
                <div className="flex justify-between mb-3">
                  <span className="font-semibold text-[16px] text-primary">
                    1. Thông tin liên hệ
                  </span>
                  <Checkbox
                    checked={isPersonChecking}
                    onChange={(e) => {
                      if (e.target.checked === true) {
                        setIsPersonChecking(true);
                      } else {
                        setIsPersonChecking(false);
                      }
                    }}
                  >
                    Là người nhận phòng
                  </Checkbox>
                </div>
                <Row gutter={12}>
                  <Col span={12}>
                    <Form.Item
                      name="contactFirstName"
                      className="mb-4"
                      rules={[
                        {
                          required: true,
                          message: "Họ không được để trống",
                        },
                      ]}
                    >
                      <Input placeholder="Họ" className="h-12" />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="contactLastName"
                      className="mb-4"
                      rules={[
                        {
                          required: true,
                          message: "Tên đệm và tên không được để trống",
                        },
                      ]}
                    >
                      <Input placeholder="Tên đệm và tên" className="h-12" />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={12}>
                  <Col span={12}>
                    <Form.Item
                      name="contactPhone"
                      rules={[
                        {
                          required: true,
                          message: "Số điện thoại không được để trống",
                        },
                        {
                          pattern: /^(03|05|07|08|09)\d{8}$|^\+84\d{9}$/,
                          message: "Số điện thoại không hợp lệ",
                        },
                      ]}
                      className="mb-4"
                    >
                      <Input placeholder="SĐT: 0912345678" className="h-12" />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="contactEmail"
                      className="mb-4"
                      rules={[
                        {
                          required: true,
                          message: "Email không được để trống",
                        },
                        {
                          type: "email",
                          message: "Vui lòng nhập email đúng định dạng",
                        },
                      ]}
                    >
                      <Input placeholder="Email" className="h-12" />
                    </Form.Item>
                  </Col>
                </Row>
                <div className="font-semibold text-[16px] text-primary mb-3">
                  2. Thông tin khách nhận phòng
                </div>

                <Row gutter={12}>
                  {/* <Col span={24} className="mb-1">
                    <div className="flex justify-between">
                      <span className="font-semibold text-[12px]">
                        Người lớn
                      </span>
                    </div>
                  </Col> */}
                  <Col
                    className="mb-1"
                    span={12}
                  >
                    <Form.Item
                      name={`first_name_adt`}
                      className="mb-4"
                      rules={[
                        {
                          required: true,
                          message: "Họ không được để trống",
                        },
                      ]}
                    >
                      <Input placeholder="Họ" className="h-12" />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name={`last_name_adt`}
                      className="mb-4"
                      rules={[
                        {
                          required: true,
                          message: "Tên đệm và tên không được để trống",
                        },
                      ]}
                    >
                      <Input placeholder="Tên đệm và tên" className="h-12" />
                    </Form.Item>
                  </Col>
                  {/* {formSearch.getFieldValue("numRooms") > 1 && (
                    <Col span={8}>
                      <Form.Item name={`room_index_adt`} className="mb-0">
                        <Select
                          placeholder="Số phòng"
                          className="h-12 bg-[#f5f6f6] font-bold"
                        >
                          {_.range(
                            1,
                            formSearch.getFieldValue("numRooms") + 1
                          ).map((room) => (
                            <Select.Option key={room} value={room}>
                              <span className="font-semibold">
                                {" "}
                                Phòng {room}
                              </span>
                            </Select.Option>
                          ))}
                          <Select.Option key={0} value={0}>
                            <span className="font-semibold">Tự sắp xếp</span>
                          </Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>
                  )} */}
                </Row>
                {/* {formSearch.getFieldValue("numAdults") > 0 &&
                  _.range(1, formSearch.getFieldValue("numAdults") + 1).map(
                    (item, index) => (
                      <Row gutter={12} key={index}>
                        <Col span={24} className="mb-1">
                          <div className="flex justify-between">
                            <span className="font-semibold text-[12px]">
                              Người lớn
                            </span>
                            <Checkbox
                              checked={item === adtChoosed}
                              onChange={(e) => {
                                if (e.target.checked === true) {
                                  setAdtChoosed(item);
                                } else {
                                  setAdtChoosed(null);
                                }
                              }}
                            >
                              Là người liên hệ
                            </Checkbox>
                          </div>
                        </Col>
                        <Col
                          className="mb-1"
                          span={
                            formSearch.getFieldValue("numRooms") > 1 ? 8 : 12
                          }
                        >
                          <Form.Item
                            name={`first_name_adt_${item}`}
                            className="mb-4"
                            rules={[
                              {
                                required: true,
                                message: "Họ không được để trống",
                              },
                            ]}
                          >
                            <Input placeholder="Họ" className="h-12" />
                          </Form.Item>
                        </Col>
                        <Col
                          span={
                            formSearch.getFieldValue("numRooms") > 1 ? 8 : 12
                          }
                        >
                          <Form.Item
                            name={`last_name_adt_${item}`}
                            className="mb-4"
                            rules={[
                              {
                                required: true,
                                message: "Tên đệm và tên không được để trống",
                              },
                            ]}
                          >
                            <Input
                              placeholder="Tên đệm và tên"
                              className="h-12"
                            />
                          </Form.Item>
                        </Col>
                        {formSearch.getFieldValue("numRooms") > 1 && (
                          <Col span={8}>
                            <Form.Item
                              name={`room_index_adt_${item}`}
                              className="mb-0"
                            >
                              <Select
                                placeholder="Số phòng"
                                className="h-12 bg-[#f5f6f6] font-bold"
                              >
                                {_.range(
                                  1,
                                  formSearch.getFieldValue("numRooms") + 1
                                ).map((room) => (
                                  <Select.Option key={room} value={room}>
                                    <span className="font-semibold">
                                      {" "}
                                      Phòng {room}
                                    </span>
                                  </Select.Option>
                                ))}
                                <Select.Option key={0} value={0}>
                                  <span className="font-semibold">
                                    Tự sắp xếp
                                  </span>
                                </Select.Option>
                              </Select>
                            </Form.Item>
                          </Col>
                        )}
                      </Row>
                    )
                  )}

                {formSearch.getFieldValue("numChilds") > 0 &&
                  _.range(1, formSearch.getFieldValue("numChilds") + 1).map(
                    (item, index) => (
                      <Row gutter={12} key={index}>
                        <Col span={24}>
                          <span className="font-semibold text-[12px]">
                            Trẻ em
                          </span>
                        </Col>
                        <Col
                          span={
                            formSearch.getFieldValue("numRooms") > 1 ? 8 : 12
                          }
                        >
                          <Form.Item
                            name={`first_name_chd_${item}`}
                            className="mb-4"
                            rules={[
                              {
                                required: true,
                                message: "Họ không được để trống",
                              },
                            ]}
                          >
                            <Input placeholder="Họ" className="h-12" />
                          </Form.Item>
                        </Col>
                        <Col
                          span={
                            formSearch.getFieldValue("numRooms") > 1 ? 8 : 12
                          }
                        >
                          <Form.Item
                            name={`last_name_chd_${item}`}
                            className="mb-4"
                            rules={[
                              {
                                required: true,
                                message: "Tên đệm và tên không được để trống",
                              },
                            ]}
                          >
                            <Input
                              placeholder="Tên đệm và tên"
                              className="h-12"
                            />
                          </Form.Item>
                        </Col>
                        {formSearch.getFieldValue("numRooms") > 1 && (
                          <Col span={8}>
                            <Form.Item
                              name={`room_index_chd_${item}`}
                              className="mb-0"
                            >
                              <Select
                                placeholder="Số phòng"
                                className="h-12 bg-[#f5f6f6] font-bold"
                              >
                                {_.range(
                                  1,
                                  formSearch.getFieldValue("numRooms") + 1
                                ).map((room) => (
                                  <Select.Option key={room} value={room}>
                                    <span className="font-semibold">
                                      {" "}
                                      Phòng {room}
                                    </span>
                                  </Select.Option>
                                ))}
                                <Select.Option key={0} value={0}>
                                  <span className="font-semibold">
                                    Tự sắp xếp
                                  </span>
                                </Select.Option>
                              </Select>
                            </Form.Item>
                          </Col>
                        )}
                      </Row>
                    )
                  )} */}
                {/* <Form.Item
                  name="occupancyPerRoom"
                  className="mb-4"
                  rules={[
                    {
                      required: true,
                      message: "Số lượng người ở tối đa 1 phòng",
                    },
                    {
                      validator: (_, value) =>
                        value && value >= 1
                          ? Promise.resolve()
                          : Promise.reject(
                              new Error("Số lượng tối thiểu là 1")
                            ),
                    },
                  ]}
                >
                  <InputNumber
                    placeholder="Số lượng người ở tối đa 1 phòng"
                    className="h-11 w-full"
                    min={1}
                  />
                </Form.Item> */}

                <Checkbox
                  size="large"
                  className="mb-3"
                  onChange={(e) => setInvoice(e.target.checked)}
                >
                  Xuất hoá đơn
                </Checkbox>

                {invoice && (
                  <>
                    <div className="self-start text-[16px] my-2 font-semibold text-primary">
                      3. Thông tin xuất hoá đơn
                    </div>

                    <Row gutter={12}>
                      <Col span={12} className="mb-3">
                        <Form.Item
                          name="VatMst"
                          className="mb-0"
                          rules={[
                            {
                              required: true,
                              message: "Mã số thuế không được để trống",
                            },
                            {
                              validator: async (_, value) => {
                                if (!value) {
                                  setInvoice("");
                                  return Promise.resolve(); // Bỏ qua nếu trường rỗng (đã được kiểm tra ở rule "required")
                                }
                                // Sử dụng Promise để trả về kết quả
                                return new Promise((resolve, reject) => {
                                  // Gọi hàm debounce và truyền callback xử lý kết quả
                                  debouncedCheckMst(value, (error) => {
                                    if (error) {
                                      reject(error); // Reject nếu có lỗi
                                    } else {
                                      resolve(); // Resolve nếu thành công
                                    }
                                  });
                                });
                              },
                            },
                          ]}
                        >
                          <Input className="h-12" placeholder="Mã số thuế" />
                        </Form.Item>
                        <span className="text-[14px] uppercase text-green-600 mt-1">
                          {invoiceCode}
                        </span>
                      </Col>
                      <Col span={12} className="mb-3">
                        <Form.Item
                          name="VatFullName"
                          className="mb-0"
                          rules={[
                            {
                              required: true,
                              message: "Tên công ty không được để trống",
                            },
                          ]}
                        >
                          <Input
                            className="h-12"
                            placeholder="Tên công ty"
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                )}
                <div className="flex justify-between items-center mt-4">
                  <div className="font-semibold text-primary">Mã giảm giá</div>
                  <Button
                    type="link"
                    onClick={() => setOpenVoucher(true)}
                    className="p-0 h-auto text-green-500 font-medium"
                  >
                    Chọn mã giảm giá
                  </Button>
                </div>
                {/* <Form.Item name="voucher" className="w-full mb-4">
                  <Input.Search
                    placeholder="Nhập mã giảm giá"
                    size="large"
                    enterButton={
                      <Button
                        type="primary"
                        style={{
                          backgroundColor: "#0064D2",
                          borderColor: "#0064D2",
                          color: "#FFFFFF",
                          fontWeight: "bold",
                        }}
                      >
                        Áp dụng
                      </Button>
                    }
                    allowClear
                    onChange={(e) => {
                      if (!e.target.value) {
                        setVoucherTxt("");
                        setVoucherValue(0);
                      }
                    }}
                    onSearch={applyVoucher}
                  />
                </Form.Item> */}
                {voucherTxt && (
                  <div
                    className="mb-4"
                    dangerouslySetInnerHTML={{ __html: voucherTxt }}
                  />
                )}
              </Form>
              <Row className="mb-2">
                <Col span={8}>
                  <div>Loại phòng: </div>
                </Col>
                <Col span={16}>
                  <div className="font-semibold text-right text-[16px] text-primary">
                    {roomSelected.roomtypename}
                  </div>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col span={8}>
                  <div>Số phòng: </div>
                </Col>
                <Col span={16}>
                  <div className="font-semibold text-right">
                    {formSearch.getFieldValue("numRooms")}
                  </div>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col span={8}>
                  <div>Người lớn: </div>
                </Col>
                <Col span={16}>
                  <div className="font-semibold text-right">
                    {" "}
                    {formSearch.getFieldValue("numAdults")}
                  </div>
                </Col>
              </Row>
              {formSearch.getFieldValue("numChilds") > 0 && (
                <Row className="mb-2">
                  <Col span={8}>
                    <div>Trẻ em: </div>
                  </Col>
                  <Col span={16}>
                    <div className="font-semibold text-right">
                      {" "}
                      {formSearch.getFieldValue("numChilds")}
                    </div>
                  </Col>
                </Row>
              )}

              <Row className="mb-2">
                <Col span={9}>
                  <div>Tổng tiền trước thuế: </div>
                </Col>
                <Col span={15}>
                  <div className="font-semibold text-right text-[16px]">
                    {" "}
                    {rateSelected.ratebeforetaxtotal?.toLocaleString(
                      "vi-VN"
                    )}{" "}
                    đ
                  </div>
                </Col>
              </Row>

              <Row className="mb-2">
                <Col span={8}>
                  <div>Tổng tiền sau thuế: </div>
                </Col>
                <Col span={16}>
                  <div className="font-semibold text-right text-[16px]">
                    {" "}
                    {rateSelected.rateaftertaxtotal?.toLocaleString(
                      "vi-VN"
                    )}{" "}
                    đ
                  </div>
                </Col>
              </Row>

              <Row className="mb-2">
                <Col span={8}>
                  <div>Giảm giá: </div>
                </Col>
                <Col span={16}>
                  <div className="font-semibold text-right text-[16px] text-green-500">
                    {" "}
                    {voucherValue.toLocaleString("vi-VN")} đ
                  </div>
                </Col>
              </Row>

              <Row className="mb-2">
                <Col span={8}>
                  <div>Tổng tiền: </div>
                </Col>
                <Col span={16}>
                  <div className="font-semibold text-right text-primary text-[24px]">
                    {" "}
                    {(
                      rateSelected.rateaftertaxtotal - voucherValue
                    ).toLocaleString("vi-VN")}{" "}
                    đ
                  </div>
                </Col>
              </Row>

              <div className="p-2 bg-[#e7ffe5] text-[#7bc27b] rounded my-4">
                Vui lòng cung cấp email và số điện thoại Việt Nam của người đặt
                phòng.
              </div>
            </div>
          )}
        </Spin>
      </Drawer>

      <Modal
        title={<div className="font-bold text-center">{hotelSelected?.Name}</div>}
        open={openHotelImagePreview}
        onCancel={() => setOpenHotelImagePreview(false)}
        footer={null}
        width={"100%"}
        centered
        destroyOnClose
      >
        <Carousel arrows infinite={(hotelSelected.Images?.length || 0) > 1} dots={false}>
          {(hotelSelected.Images?.length > 0 ? hotelSelected.Images : [hotelSelected?.Thumbnail].filter(Boolean)).map((img, i) => (
            <div key={i}>
              <img
                src={img?.large || img?.origin}
                alt=""
                className="w-full h-[480px] object-contain bg-black"
              />
            </div>
          ))}
        </Carousel>
      </Modal>

      <Modal
        title={<div className="font-bold text-center">Chọn mã giảm giá</div>}
        open={openVoucher}
        onCancel={() => setOpenVoucher(false)}
        footer={null}
        width="100%"
        className="voucher-modal-mobile"
        styles={{
          body: { padding: '16px' }
        }}
      >
        <List
          dataSource={vouchers}
          locale={{ emptyText: <div className="py-8 text-gray-400 text-center">Không có mã giảm giá khả dụng</div> }}
          renderItem={(item) => (
            <List.Item className="border-b last:border-0 py-4 px-0">
              <div className="flex justify-between items-center w-full gap-3">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="bg-blue-100 text-blue-700 px-2 py-0.5 rounded text-[10px] font-bold">
                      {item.code}
                    </span>
                    <span className="text-sm font-bold text-gray-800">
                      Giảm {item.amountvoucher.toLocaleString("vi-VN")} đ
                    </span>
                  </div>
                  <div className="text-xs text-gray-500 line-clamp-1">
                    {item.description}
                  </div>
                  <div className="text-[10px] text-gray-400 mt-1">
                    HSD: {dayjs(item.enddate).format("DD/MM/YYYY")}
                  </div>
                </div>
                <Button
                  type="primary"
                  size="small"
                  onClick={() => applyVoucherPick(item)}
                  className="rounded-full px-4 h-8 shrink-0"
                >
                  Dùng
                </Button>
              </div>
            </List.Item>
          )}
        />
      </Modal>
    </>
  );
};

export default ChooseHotel;
